
/*
  Instagram Gallery
*/
const initInstagramGallery = async () => {
  if (document.querySelectorAll('.instagram-gallery').length) {
    const splideScrollScript = document.createElement('script')
    splideScrollScript.src = document.querySelector('.instagram-gallery').dataset.vendorSplideScrollScript
    document.head.appendChild(splideScrollScript)
  }

  await new Promise(resolve => setTimeout(resolve, 500))

  document.querySelectorAll('.instagram-gallery').forEach(async (section) => {
    const element = section.querySelector('.splide')

    let speed = Number(element.dataset.speed)

    if (element.dataset.direction === 'right') {
      speed = -Math.abs(speed)
    }

    const mySplide = new Splide(element, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      arrows: element.dataset.arrows === 'true',
      pagination: false,
      easing: element.dataset.easing,
      gap: Number(element.dataset.gap),
      mediaQuery: 'min',
      breakpoints: {
        0: { perPage: Number(element.dataset.breakpointXs), padding: 0 },
        576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
        768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
        992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
        1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
        1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
      },
      autoScroll: {
        speed
      },
      direction: document.documentElement.getAttribute('dir')
    })
    mySplide.mount(window.splide.Extensions)
  })
}
initInstagramGallery()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.instagram-gallery')) {
    initInstagramGallery()
  }
})
